import React from 'react'

import { Divider as MuiDivider, DividerProps } from '@mui/material'
type DividerCustomProps = DividerProps

const Divider: RFC<DividerCustomProps> = (props) => {
  return <MuiDivider {...props} />
}

export default Divider
